export default __webpack_public_path__ + "static/media/oleg-illarionov-q9q8bi0Aw7o-unsplash_MOBILE.590e6d98.jpg";